import React from 'react';
import { ContactsUploadProvider } from './provider';
import { UploadComponent } from '../../csv-upload-wizard';
import { CONTEXT_TYPE } from '../use-upload-context-factory';

export function ContactsUploadWizard() {
  return (
    <ContactsUploadProvider>
      <UploadComponent contextType={CONTEXT_TYPE.CONTACTS} />
    </ContactsUploadProvider>
  );
}
